import { MDBBadge, MDBIcon } from "mdb-react-ui-kit";
import PropTypes from "prop-types";
import React from "react";
import { useHistory } from "react-router-dom";
import { addNewResume } from "../services/httpService";

export default function ResumeAddNew( { user } ) {
    const history = useHistory();

    const createResume = ( event ) => {
        if ( event ) {
            event.preventDefault();
        }

        if ( !user || !user.id ) {
            console.error( "Impossible de créer un CV : utilisateur manquant ou non chargé." );
            return;
        }

        const manager = user?.manager
            ? {
                id: user.manager?.id ?? null,
                firstName: user.manager?.prenom ?? null,
                lastName: user.manager?.nom ?? null,
                email: user.manager?.email ?? null,
                phone: user.manager?.phone ?? null,
            }
            : null;

        const newResume = {
            id: null,
            userId: user.id,
            properties: [],
            document: {
                user: {
                    id: user.id,
                    firstName: user?.prenom ?? null,
                    lastName: user?.nom ?? null,
                    email: user?.email ?? null,
                    phone: user?.phone ?? null,
                    country: user?.pays ?? null,
                },
                manager: manager,
                introduction: null,
                languageSkills: [],
                businessSkills: [],
                experiences: [],
                totalExperienceDuration: null,
                diplomas: [],
                hobbies: [],
            },
            status: 'NON_COMMENCE',
            creationDate: new Date( Date.now() ).toISOString(),
            lastModificationDate: null
        }

        addNewResume( newResume )
            .then( response => response.json() )
            .then( data => {
                if ( data === undefined || data.id === undefined || data.id === null ) {
                    throw new Error( 'Data is undefined' );
                }
                history.push( `/mon-espace-cv/${ user.id }/${ data.id }` );
            } )
            .catch( error => console.error( error ) );

    };

    return <div className="d-flex justify-content-between mb-3">
        <div></div>
        <div className="d-flex align-items-center" style={ { cursor: "pointer" } }>
            <MDBBadge
                className="mx-2 ms-5"
                color="info"
                light
                onClick={ createResume }
            >
                Créer un CV
            </MDBBadge>
            <div onClick={ createResume } role="button">
                <MDBIcon
                    fas
                    icon="plus-circle"
                    size="2x"
                    style={ { color: "#09B4BF" } }
                />
            </div>
        </div>
    </div>
        ;
}

ResumeAddNew.propTypes = {
    user: PropTypes.object.isRequired,
};
